import React from "react";
import { Helmet } from "react-helmet";

const CustomeHelmet = ({ title, description }) => {
  return (
    <>
      <Helmet>
        <title> {`${title} |  MS Digital Media`}</title>
        <meta name="description" content={`${description}`} />
      </Helmet>
    </>
  );
};

export default CustomeHelmet;
